import { api } from '../api';


export async function getParametersService(key) {
    try {
        const response = await api.get(`/parametro-sistema?parametro=${key}`)
        return response
    }
    catch (error) {
        return false
    }
}